import { RelatedDocument } from './related-document.type';

export interface FileReferenceDocument {
  fileDetails: FileReferenceDetails[],
  relatedDocument: RelatedDocument[]
}

export interface FileReferenceDetails {
  basePath: string;
  ext: string;
  fileName: string;
  fileNo: string;
  fileType: string;
}
